(ns frontend.view.settings2.surveys.timeseries.view
  (:require [frontend.view.settings2.surveys.timeseries.event :as event]
            [frontend.view.settings2.surveys.timeseries.model :as model]
            [frontend.view.settings2.surveys.timeseries.sub :as sub]
            [frontend.view.settings2.surveys.timeseries.tab-forecast :as tab-forecast]
            [frontend.view.settings2.surveys.timeseries.tab-history :as tab-history]
            [frontend.view.settings2.surveys.timeseries.tab-metrics :as tab-metrics]
            [frontend.view.settings2.surveys.timeseries.tab-preview :as tab-preview]
            [re-frame.core :as rf]
            [ui.components.tab-strip.view :as tabs]
            [ui.util :as uu]))

(defn tab-selector
  [{:keys [ctx-path] :as ctx}]
  (let [current-tab-key-str (:tab-str-key @(rf/subscribe [::sub/selected-tab ctx-path]))]
    [:div
     {:class "*:w-full flex justify-between items-center"}
     [tabs/view
      {:tabs         (->> model/tabs
                          (mapv (fn [{:keys [tab-str-key tab-label tab-icon disabled?]}]
                                  {:value     tab-str-key
                                   :disabled? disabled?
                                   :label     [:span
                                               [:i {:class (uu/cm "fal text-sm m-0" tab-icon)}]
                                               tab-label]})))
       :selected-tab current-tab-key-str
       :on-change!   (fn [tab]
                       (rf/dispatch-sync [::event/set-view-editor-tab (assoc ctx :new-tab-str tab)]))}]]))

(defn tab-content
  [{:keys [ctx-path] :as ctx} block]
  (let [{:keys [tab-key]} @(rf/subscribe [::sub/selected-tab ctx-path])]
    (condp = tab-key
      (:tab-key model/tab-historical-data) [tab-history/view ctx block]
      (:tab-key model/tab-forecast-data) [tab-forecast/view ctx block]
      (:tab-key model/tab-metrics) [tab-metrics/view ctx block]
      [tab-preview/view ctx block])))

(defn view
  [ctx block]
  [:<>
   [tab-selector ctx]
   [tab-content ctx block]])
